
import React, { useEffect, useState, useRef } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Modal, Stack, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';
import PageLoader from "../commoncomponents/PageLoader";
import "../../assets/css/reports.css";
import "../../assets/css/assetreport.css";
import { DefaultCard } from "../../assets/styled-components/card";
import { getAuthToken } from "../../utility/tokenUtility";
import PageTitle from "../commoncomponents/PageTitle";
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import { BemsGraph, FemsGraph } from '../../utility/apiURLS';
import { ErrorChips, SuccessChips, WarningChips } from '../../assets/styled-components/chips';
import RefreshExportButtons from '../commoncomponents/RefreshExportButtons';
import SectionTitle from '../commoncomponents/SectionTitle';
import { useAccess } from '../../AccessContext';
import utilities from '../../utility/utilities';
import CustomDialog from '../commoncomponents/CustomDialog';
import CustomTextField from '../commoncomponents/CustomTextField';
import VisibilityIcon from "@mui/icons-material/Visibility";

const AssetTransferList = () => {
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [rowsId, setRowsId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [workorderlistloading, setWorkorderListLoading] = useState(false);
    const [cancelLoading, setCancelLoading] = useState(false);
    const [workorderrows, setWorkorderRows] = useState([]);
    const [assethistoryrows, setAssetHistoryRows] = useState([]);
    const [gridApi, setGridApi] = useState({});
    const [gridApiList, setGridApiList] = useState({});
    const [gridApiHistoryList, setGridApiHistoryList] = useState({});
    const [loading, setLoading] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
    const [transferdialogOpen, setTransferDialogOpen] = useState(false);
    const [sucessDialogOpen, setSucessDialogOpen] = useState(false);
    const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
    const [opencancelDialog, setOpenCancelDialog] = useState(false);
    const [cancelReason, setCancelReason] = useState("");
    const [cancelBy] = useState(localStorage.getItem("UserName") || "");
    const [dailogContent, setDailogContent] = useState("");
    const [assetid, setAssetid] = useState('');
    const token = getAuthToken("id_token");
    const [error, setError] = useState({
        cancelReason: false
    });
    const [errorMessage, setErrorMessage] = useState({
        cancelReason: ""
    });
    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "ENGM015");

    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const columns = [
        { field: "assetno", headerName: "Asset No" },
        { field: "workgroupcode", headerName: "WG Code" },
        { field: "workgroupdesc", headerName: "WG Desc" },
        { field: "assetstatus", headerName: "Asset Status" },
        { field: "service", headerName: " Service" },
        { field: "oldHospital", headerName: "Old Hospital" },
        { field: "newHospital", headerName: "New Hospital" },
        { field: "transferredby", headerName: "Transfer By" },
        { field: "transferreddate", headerName: "Transfer Date" },
        ...(access?.canAuthorize ? [
            {
                field: "approveRejectTransfer",
                headerName: "Approve / Reject Transfer",
                minwidth: 280,
                maxWidth: 280,
                cellRenderer: (params) => {
                    return (
                        <div style={{ display: 'flex', gap: '30px' }}>
                            <Button
                                variant="contained"
                                color="success"
                                size="small"
                                sx={{ minWidth: 50 }}
                                onClick={() => handleApprove(params.data)}
                            >
                                <CheckCircleIcon />
                            </Button>

                            <Button
                                variant="contained"
                                color="error"
                                size="small"
                                sx={{ minWidth: 50 }}
                                onClick={() => handleReject(params.data)}

                            >
                                <CancelIcon />
                            </Button>
                        </div>
                    );
                }
            }
        ] : [])

    ];


    const Historycolumns = [
        { field: "assetno", headerName: "Asset No" },
        { field: "service", headerName: " Service" },
        { field: "oldHospital", headerName: "Old Hospital" },
        { field: "newHospital", headerName: "New Hospital" },
        { field: "transferredby", headerName: "Transfer By" },
        { field: "transferreddate", headerName: "Transfer Date" },
        { field: "approvedby", headerName: "Approve By" },
        { field: "approveddate", headerName: "Approve Date" },
        { field: "newApprovedby", headerName: "New Hospital Approve By" },
        { field: "newApproveddate", headerName: "New Hospital Approve Date" },
        { field: "rejectedby", headerName: "Rejected By" },
        { field: "rejecteddate", headerName: "Rejected Date" },
    ];

    const workordercolumns = [
        { field: "workorderno", headerName: "Work Order No." },
        { field: "requestDetails", headerName: "Request Details" },
        { field: "targetDateFormate", headerName: "Target Date" },
        { field: "title", headerName: "W.O Type" },
        { field: "service", headerName: "Service" },
        {
            field: "status", headerName: "Status",
            cellRenderer: (params) => {
                if (params.value === "Closed" || params.value === "Verified" || params.value === "Completed" || params.value === "Completed-Outsource") {
                    return <SuccessChips label={params.value} />;
                }
                if (params.value === "In Progress" || params?.value === "In Progress-Outsource") {
                    return <WarningChips label={params.value} />;
                } else {
                    return <ErrorChips label={params.value} />;
                }
            },
        },
    ];


    useEffect(() => {
        fetchAssetTransferList();
    }, []);

    const handleOnChange = (value, name) => {

        if (name === "cancelReason") {
            setCancelReason(value);
        }

        // Reset error and error message for the specific field
        setError((prevError) => ({
            ...prevError,
            [name]: false,  // Dynamically reset error for the specific field
        }));

        setErrorMessage((prevErrorMessage) => ({
            ...prevErrorMessage,
            [name]: "",  // Dynamically reset error message for the specific field
        }));
    };


    const fetchAssetTransferList = async () => {
        setRows([]);
        setIsLoading(true);

        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const facilityid = localStorage.getItem("facilityId")
            // Fetch data from both endpoints concurrently
            const [femResponse, bemResponse] = await Promise.all([
                axios.get(
                    `${FemsGraph}/api/AssetTransfer/FemAssetTransferCheckOut/${facilityid}/${token}`,
                    config
                ),
                axios.get(
                    `${BemsGraph}/api/AssetTransfer/BemAssetTransferCheckOut/${facilityid}/${token}`,
                    config
                ),
            ]);


            // Combine data from both responses
            const combinedData = [
                ...femResponse.data,
                ...bemResponse.data,
            ];


            setRows(combinedData);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setIsLoading(false);
        }
    };


    const fetchassethistoryList = async () => {
        setAssetHistoryRows([]);
        setHistoryDialogOpen(true);
        setIsLoading(true);

        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            const facilityid = localStorage.getItem("facilityId")
            // Fetch data from both endpoints concurrently
            const [femResponse, bemResponse] = await Promise.all([
                axios.get(
                    `${FemsGraph}/api/AssetTransfer/GetAssetTransferHistory/${facilityid}/${token}`,
                    config
                ),
                axios.get(
                    `${BemsGraph}/api/AssetTransfer/GetAssetTransferHistory/${facilityid}/${token}`,
                    config
                ),
            ]);


            // Combine data from both responses
            const combinedData = [
                ...femResponse.data,
                ...bemResponse.data,
            ];


            setAssetHistoryRows(combinedData);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleHistoryClick = () => {
        fetchassethistoryList();
    }

    const handleCancel = () => {

        navigate("/dashboard");


    };
    const handleRefresh = () => {
        fetchAssetTransferList();
    };

    const ErrorDailogclose = () => {
        setRejectDialogOpen(false);
        setSucessDialogOpen(false);
        fetchAssetTransferList();

    }

    const handleApprove = (rowData) => {
        setDialogOpen(true);
        fetchAssetworkorderlist(rowData);
        setRowsId(rowData);


    }

    const handleCancelWO = async () => {

        setOpenCancelDialog(true);
    }

    const handlecancelClose = async () => {

        setOpenCancelDialog(false);
        // Reset error and error message for the specific field
        setError((prevError) => ({
            ...prevError,
            cancelReason: false,  // Dynamically reset error for the specific field
        }));

        setErrorMessage((prevErrorMessage) => ({
            ...prevErrorMessage,
            cancelReason: "",  // Dynamically reset error message for the specific field
        }));
    }

    const handleconfirm = async () => {
        try {
            setCancelLoading(true);
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            // Validation
            if (!cancelReason) {
                setErrorMessage({ cancelReason: "Cancel Reason is required" });
                setError({ cancelReason: true });
                return;
            }

            // Separate rows by service
            const femsRows = workorderrows.filter(row => row.service === "FEMS");
            const bemsRows = workorderrows.filter(row => row.service === "BEMS");


            // Build payloads
            const femsPayload = femsRows.map(row => ({
                id: row.id,
                cancelby: cancelBy,
                cancelreason: cancelReason,
                type: row.title
            }));

            const bemsPayload = bemsRows.map(row => ({
                id: row.id,
                cancelby: cancelBy,
                cancelreason: cancelReason,
                type: row.title
            }));

            // API calls (only if payload has data)
            if (femsPayload.length > 0) {
                await axios.post(
                    `${FemsGraph}/api/AssetTransfer/FemCancelledWorkorderstatus`,
                    femsPayload,
                    config
                );
            }

            if (bemsPayload.length > 0) {
                await axios.post(
                    `${BemsGraph}/api/AssetTransfer/BemCancelledWorkorderstatus`,
                    bemsPayload,
                    config
                );
            }


            setOpenCancelDialog(false);
            setCancelReason("");
            fetchAssetworkorderlist(rowsId);

        } catch (error) {
            console.error("Error cancelling work orders", error);
        } finally {
            setCancelLoading(false);
        }

    };


    const handleTransfer = async (rowData) => {

        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            let response;
            const payload = {
                id: rowsId.id,
                Approveby: localStorage.getItem("UserName"),
                Approve: 1
            }

            if (rowsId.service === "FEMS") {
                response = await axios.post(
                    `${FemsGraph}/api/AssetTransfer/updateAssetTransferstatus`, payload,
                    config
                );
            } else {
                response = await axios.post(
                    `${BemsGraph}/api/AssetTransfer/updateAssetTransferstatus`, payload,
                    config
                );
            }

            setDialogOpen(false);
            setSucessDialogOpen(true);
            setDailogContent("Asset Transfer Successfully.");

        } catch (error) {
            console.error("Error fetching data", error);
        }
    }

    const handleReject = async (rowData) => {
        try {
            const token = getAuthToken("id_token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            let response;
            const payload = {
                id: rowData.id,
                Approveby: localStorage.getItem("UserName"),
                Approve: 2
            }

            if (rowData.service === "FEMS") {
                response = await axios.post(
                    `${FemsGraph}/api/AssetTransfer/updateAssetTransferstatus`, payload,
                    config
                );
            } else {
                response = await axios.post(
                    `${BemsGraph}/api/AssetTransfer/updateAssetTransferstatus`, payload,
                    config
                );
            }

            setRejectDialogOpen(true);
            setDailogContent("Asset Reject Successfully.")

        } catch (error) {
            console.error("Error fetching data", error);
        }
    }

    const fetchAssetworkorderlist = async (rowData) => {

        setWorkorderRows([]);
        setWorkorderListLoading(true);

        try {
            const token = getAuthToken("id_token");

            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            let response;

            if (rowData.service === "FEMS") {
                response = await axios.get(
                    `${FemsGraph}/api/AssetTransfer/FemAssetTransferAssetId/${rowData.assetId}`,
                    config
                );
            } else {
                response = await axios.get(
                    `${BemsGraph}/api/AssetTransfer/BemAssetTransferAssetId/${rowData.assetId}`,
                    config
                );
            }

            setWorkorderRows(response.data);
        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            setWorkorderListLoading(false);
        }
    };


    return (
        <>
            <PageLoader open={loading} />
            <PageTitle title={"Asset Transfer"} />
            <Box mt={{ xs: 1, sm: 2 }}>,
                <DefaultCard>
                    <Box
                        mb={1}
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                        }}
                    >



                        <SectionTitle title={"Asset Transfer List"} />
                        <Stack direction={"row"} spacing={1}>
                            <Button
                                sx={{ paddingLeft: "10px", paddingRight: "10px" }}
                                variant="contained"
                                onClick={handleHistoryClick}
                                startIcon={<VisibilityIcon />}
                            >
                                View Asset History
                            </Button>
                            <RefreshExportButtons
                                pagination={true}
                                exportFunction={() => { }}
                                exportData={rows}
                                refData={gridApi}
                                enableDownload={false}
                                handleRefresh={handleRefresh}
                            />
                        </Stack>
                    </Box>

                    <DefaultCard sx={{ mt: 3 }}>
                        <CustomAgGrid
                            rows={rows}
                            columns={columns}
                            ref={gridApi}
                            setGridApi={setGridApi}
                            pagination={true}
                            isLoading={isLoading}
                        />
                    </DefaultCard>

                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: { xs: "center", md: "end" },
                            mt: 3,
                        }}
                    >
                        <Button variant='outlined' onClick={handleCancel}>Close</Button>

                    </Box>
                </DefaultCard >

                <Dialog
                    open={dialogOpen}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            setDialogOpen(false);
                        }
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    fullWidth
                    maxWidth="md" // sm / md / lg based on how wide you want
                >
                    <PageLoader open={workorderlistloading} />
                    <Box sx={{
                        p: 3,
                        width: "100%",
                        maxHeight: "80vh",
                        overflowY: "auto",
                    }}>
                        {(workorderrows.length > 0 &&
                            <Alert severity="warning" sx={{ mb: 2, fontSize: "16px" }}>
                                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                    Please Note *
                                </Typography>
                                <Typography variant="body1">
                                    The listed work orders must first be moved to the Cancelled status by clicking the Cancel WO button. Only then will the Transfer button be enabled.
                                </Typography>
                            </Alert>
                        )}
                        <CustomAgGrid
                            rows={workorderrows}
                            columns={workordercolumns}
                            ref={gridApiList}
                            setGridApi={setGridApiList}
                            pagination={true}
                            isLoading={workorderlistloading}
                        />
                        <br />
                        <Box sx={{ display: 'flex', justifyContent: 'end', gap: 2, mb: 2 }}>

                            <Button variant="contained" color="primary" disabled={!(workorderrows.length > 0)} onClick={() => handleCancelWO()}>
                                Cancel WO
                            </Button>

                            <Button variant="contained" color="primary" disabled={(workorderrows.length > 0)} onClick={(rowData) => handleTransfer(rowData)}>
                                Transfer
                            </Button>

                            <Button variant="outlined" onClick={() => setDialogOpen(false)}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>

                </Dialog>

                <Dialog
                    open={opencancelDialog}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            setOpenCancelDialog(false);
                        }
                    }}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>Reason For Cancel</DialogTitle>
                    <PageLoader open={cancelLoading} />

                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <CustomTextField
                                    label="Cancel by"
                                    id="cancel-by"
                                    name="cancelBy"
                                    disabled={true}
                                    value={cancelBy || ""}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <CustomTextField
                                    label="Cancel Reason"
                                    id="cancel-reason"
                                    name="cancelReason"
                                    isMandatoryField={true}
                                    value={cancelReason}
                                    onChange={handleOnChange}
                                    error={error?.cancelReason}
                                    errorMessage={errorMessage?.cancelReason}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        {/* Continue button that triggers the next step */}
                        <Button onClick={handleconfirm} color="primary" variant="contained">
                            Confrim
                        </Button>
                        {/* OK button to close the dialog */}
                        <Button onClick={handlecancelClose} color="primary" variant="outlined">
                            cancel
                        </Button>
                    </DialogActions>
                </Dialog>


                <Dialog
                    open={historyDialogOpen}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            setHistoryDialogOpen(false);
                        }
                    }}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    fullWidth
                    maxWidth="lg" // sm / md / lg based on how wide you want
                >
                    <PageLoader open={workorderlistloading} />
                    <Box sx={{
                        p: 3,
                        width: "100%",
                        maxHeight: "80vh",
                        overflowY: "auto",
                    }}>
                        <Typography variant="h6" sx={{ fontWeight: 700 }}>
                            Asset Transfer History
                        </Typography>

                        <CustomAgGrid
                            rows={assethistoryrows}
                            columns={Historycolumns}
                            ref={gridApiHistoryList}
                            setGridApi={setGridApiHistoryList}
                            pagination={true}
                            isLoading={workorderlistloading}
                        />
                        <br />
                        <Box sx={{ display: 'flex', justifyContent: 'end', gap: 2, mb: 2 }}>
                            <Button variant="outlined" onClick={() => setHistoryDialogOpen(false)}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>

                </Dialog>

                <CustomDialog
                    open={sucessDialogOpen}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            ErrorDailogclose();
                        }
                    }}
                    content={dailogContent}
                    cancelBtn="Ok"
                />

                <CustomDialog
                    open={rejectDialogOpen}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            ErrorDailogclose();
                        }
                    }}
                    content={dailogContent}
                    cancelBtn="Ok"
                />


            </Box >



        </>
    );

}
export default AssetTransferList;
